import * as React from 'react';
import { Link } from 'react-router-dom';
import { Table } from '../../components/tables/Table';
import { TransportationUtils } from '../../transportation/helpers';
import { ShipToAddressRead } from '../models/ship-to-address-read';

interface IProps {
    dealerId: string;
    addresses: ShipToAddressRead[];
    onClick: any;
    enableLink?: boolean;
}

const DeliveryAddressesTable = (props: IProps) => {

    const [selectedRow, setSelectedRow] = React.useState(0);

    const onRowClick = (itm: ShipToAddressRead) => {
        if (props.onClick) {
            setSelectedRow(itm.id);
            props.onClick(itm);
        }
    };

    const getDisplay = (itm: ShipToAddressRead) => {
        return TransportationUtils.isValidAddress(itm.address)
            ? itm.name
            : `${itm.name} [INVALID ADDRESS]`;
    };

    const getApprovalDisplay = (itm: ShipToAddressRead) => {
        if(itm.isNew && itm.orderIds.length > 0) {
            return 'Pending';
        }

        return 'X';
    };

    return <React.Fragment>
        <div className="row">
            <div className="col-md-12">
                <Table rowClass="dealer-address-row"
                    tableClass="center-last-column"
                    transparentBackground={true}
                    noResultsMessage="This dealer has no addresses."
                    header={['Name', 'Address', 'Phone Number', 'Job Site', 'Approved']}>
                    {
                        props.addresses.map((itm: ShipToAddressRead, idx: number) => {
                            return <tr
                                key={idx}
                                onClick={() => onRowClick(itm)}
                                className={`chi-styled-row ${selectedRow === itm.id ? 'highlighted' : ''}`} >
                                <td>
                                    {
                                        props.enableLink
                                            ? <Link to={{
                                                pathname: `/support/dealers/${props.dealerId}/addresses/${itm.id}`,
                                                state: itm
                                            }}>
                                                {getDisplay(itm)}
                                            </Link>
                                            : getDisplay(itm)
                                    }
                                </td>
                                <td>{itm.address && itm.address.isDefault ? <i className={`la la-star`} /> : null} {(itm.address && itm.address.addressLine1) ? itm.address.addressLine1 : ''}</td>
                                <td>{itm.phoneNumber ? itm.phoneNumber : ''}</td>
                                <td className="table-cell-center" >{itm.isJobSite ? 'X' : ''}</td>
                                <td className="table-cell-center" >{getApprovalDisplay(itm)}</td>
                            </tr>;
                        })
                    }
                </Table>
            </div>
        </div>
    </React.Fragment>;

};

DeliveryAddressesTable.defaultProps = {
    onClick: undefined,
    enableLink: true
};

export { DeliveryAddressesTable };
